import React, { useRef, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  countryCodeListing,
  getJobDetailById,
  addCandidateData,
  addCvDetails,
  getSkillDetails,
  getQualificationList,
  createResumeSkill,
  candidateFileUpload,
  candidateFileDelete,
  getCountryDetails,
  addSkillsMaster,
} from "./action";
import InputMask from "react-input-mask";
// import bgImg from "../../assets/images/main-bg.png";
import inicLogo from "../../assets/images/INIC-logo.png";
import IndianicLogo from "../../assets/images/_indianic-white-logo.svg";
import moment from "moment";
import {
  Badge,
  Container,
  Form,
  Row,
  Col,
  Image,
  Button,
  Modal,
  Spinner,
  ModalBody,
} from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import SimpleSelectComponent from "../../components/SimpleSelect/SimpleSelectComponent";
import MultiSelectComponent from "../../components/Multiselect/MultiSelectComponent";
import DatePicker from "react-datepicker";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import {
  emailValidator,
  showErrorToast,
  showSuccessToast,
  textValidator,
} from "../../utils/Functions";
import Footer from "./../../components/Footer";
import swal from "sweetalert";
import ToolTipComponent from "../../components/ToolTip/ToolTipComponent";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import docIcon from "../../assets/images/icons-doc.png";
import PhoneInput from "react-phone-input-2";
import DocViewer, {
  PDFRenderer,
  MSDocRenderer,
  PNGRenderer,
  JPGRenderer,
} from "react-doc-viewer";
import { REACT_APP_FILE_UPLOAD } from "../../config";

// Skill chips read from a resume that aren't in the skill master yet
const NEW_SKILL_PREFIX = "new:";

// Wizard steps, in order; one section is shown per step
const STEP_KEYS = ["upload", "basic", "professional", "experience", "education", "address"];
// Error keys checked when leaving a step with "Next" (experience / education are optional;
// the resume is only checked on Submit, see handleSubmit)
const STEP_REQUIRED = {
  basic: ["firstName", "lastName", "email", "mobile", "noticePeriod"],
  professional: ["qualification", "currentEmployer", "totalExperiance", "currentSalary", "skillSet"],
  address: ["city", "country"],
};
const LAST_STEP = STEP_KEYS.length - 1;

// Experience / education dates are stored as "MM/YYYY" strings
const MONTH_FORMAT = "MM/YYYY";
const emptyExperience = () => ({
  occupation: "",
  company: "",
  summary: "",
  from: "",
  to: "",
  isWorking: false,
});
const emptyEducation = () => ({
  institute: "",
  major: "",
  degree: "",
  from: "",
  to: "",
  pursuing: false,
});

const toMonthDate = (value) => {
  const date = moment(value, MONTH_FORMAT, true);
  return date.isValid() ? date.toDate() : null;
};

// The resume parser gives dates like "2016", "Jan 2021" or "Present"
const normalizeMonth = (value) => {
  const date = moment(
    String(value || "").trim(),
    [MONTH_FORMAT, "M/YYYY", "MMM YYYY", "MMMM YYYY", "YYYY-MM", "YYYY"],
    true
  );
  return date.isValid() ? date.format(MONTH_FORMAT) : "";
};
const isPresent = (value) => /present|current|till date|now/i.test(String(value || ""));

// An entry counts once any of these has text
const hasText = (item, keys) => keys.some((key) => String(item[key] || "").trim() !== "");
const EXPERIENCE_KEYS = ["occupation", "company", "summary", "from", "to"];
const EDUCATION_KEYS = ["institute", "major", "degree", "from", "to"];

// Placeholder for a form section while the resume is being read
const FormSkeleton = ({ fields }) => (
  <div className="nic-form-skeleton">
    {Array.from({ length: fields }, (_, index) => (
      <div className="nic-skeleton-field" key={index}>
        <span className="nic-skeleton-bar is-label" />
        <span className="nic-skeleton-bar" />
        <span className="nic-skeleton-bar is-short" />
      </div>
    ))}
  </div>
);

const JobDetails = () => {
  let typingTimer;
  const timeOut = useRef();
  const param = useParams();
  const dispatch = useDispatch();
  const jobData = useSelector((state) => state.career.getJobData);

  const skillDetail = useSelector((state) => state.career.getSkillList.data);

  const addJob = useSelector((state) => state.career.addJobOpening);

  const fileUpload = useSelector((state) => state.career.getCandidateCvDetails);

  const code = useSelector((state) => state.career.getCountryCode.data);
  const [isLoading, setIsLoading] = useState(false);
  const qualificationDetail = useSelector(
    (state) => state.career.getQualificationDetails
  );

  const [interested, setInterested] = useState(false);
  const [skillSetOption, setSkillSetOption] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState([]);
  const [showPhotoMenu, setShowPhotoMenu] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [showPhotoPreview, setShowPhotoPreview] = useState(false);
  const [capturedPhoto, setCapturedPhoto] = useState("");
  const [cameraError, setCameraError] = useState("");
  const avatarRef = useRef();
  const [showReplaceResume, setShowReplaceResume] = useState(false);
  const [parsingResume, setParsingResume] = useState(false);
  const replaceInputRef = useRef();
  const replaceModeRef = useRef("resume");
  // Changes each time the candidate leaves the form, so late resume results are ignored
  const applicationRef = useRef(0);
  const videoRef = useRef();
  const streamRef = useRef();
  const [jobSuccess, setJobSuccess] = useState(false);
  const [startMonth, setStartMonth] = useState("");
  const [experienceStartMonth, setExperienceStartMont] = useState();
  const [phoneCodeOptionsData, setPhoneCodeOptionsData] = useState([]);
  const [show, setShow] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [file, setFile] = useState();
  const [image, setImage] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();

  const [fileList, setFileList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const [fileType, setFileType] = useState("");
  const [uploadList, setUploadList] = useState([]);

  const [jobApplicationData, setJobApplicationData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    phoneCode: "",
    noticePeriod: "",
    currentEmployer: "",
    totalExperiance: "",
    currentSalary: "",
    skillSet: [],
    educationalDetails: [],
    experienceDetails: [],
    faceBook: "",
    linkdin: "",
    summary: "",
    street: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
    resume: "",
    photo: "",
    qualificationId: "",
    qualification: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    phoneCode: "",
    noticePeriod: "",
    currentEmployer: "",
    totalExperiance: "",
    currentSalary: "",
    skillSet: "",
    educationalDetails: [],
    experienceDetails: [],
    faceBook: "",
    linkdin: "",
    summary: "",
    street: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",

    qualificationId: "",
    qualification: "",
  });

  const [educationDetails, setEducationDetails] = useState([emptyEducation()]);

  const [experienceDetails, setExperienceDetails] = useState([emptyExperience()]);
  const [activeStep, setActiveStep] = useState(0);
  const isStepActive = (key) => STEP_KEYS[activeStep] === key;

  const countryList = useSelector((state) => state.career.getCountryDetails);

  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    dispatch(getJobDetailById(param.id));
  }, []);

  useEffect(() => {
    dispatch(getSkillDetails());
    dispatch(getCountryDetails());
  }, []);

  useEffect(() => {
    let countryArray = [];
    countryList.length > 0 &&
      countryList.map((country) =>
        countryArray.push({
          label: country.countryName,
          value: country.countryName,
        })
      );

    setCountryOptions(countryArray);
  }, [countryList]);

  useEffect(() => {
    if (skillDetail && skillDetail.length > 0) {
      const list = [];
      skillDetail?.map((item) => {
        return list.push({
          label: item?.skill,
          value: item?._id,
        });
      });

      if (selectedSkill.length > 0) {
        let selectedSkillList = [];
        selectedSkill.map((data) => {
          selectedSkillList.push(
            list.filter((dat) => dat.label === data.label)[0] || data
          );
        });

        setSelectedSkill(selectedSkillList);
        setJobApplicationData({
          ...jobApplicationData,
          skillSet: selectedSkillList.map((data) => data.value),
        });
      }
      setSkillSetOption([
        ...list,
        {
          label: "",
          value: "",
        },
      ]);
    } else {
      setSkillSetOption([]);
    }
  }, [skillDetail]);

  useEffect(() => {
    dispatch(countryCodeListing());

    dispatch(getQualificationList());
  }, []);

  useEffect(() => {
    if (addJob && addJob.status === 1) {
      const addFiles = Promise.all(
        uploadList.map((item) => {
          let payload = new FormData();
          payload.append("userId", addJob?.data?._id);
          payload.append("type", item.name);
          payload.append("file", item.item);
          // return dispatch(candidateFileUpload(payload));
        })
      );

      if (uploadList?.length > 0) {
        Promise.all([addFiles]).then((values) => {
          setJobSuccess(true);
          setIsLoading(false);
          setShow(true);
          showSuccessToast(addJob.message);
        });
      } else {
        setJobSuccess(true);
        setShow(true);
        showSuccessToast(addJob.message);
      }
    }
  }, [addJob]);

  // useEffect(() => {
  //   // if (fileUpload) {
  //   //   let list = [];
  //   //   let ids = [];
  //   //   fileUpload?.data?.candidateSkillSet.map((item) =>
  //   //     list.push({ value: item._id, label: item.skill })
  //   //   );
  //   //   setSelectedSkill(list);
  //   //   fileUpload?.data?.candidateSkillSet.map((item) => {
  //   //     if (item._id !== "") {
  //   //       ids.push(item._id);
  //   //     }
  //   //   });
  //   //   setJobApplicationData({
  //   //     ...jobApplicationData,
  //   //     firstName: fileUpload?.data?.firstName
  //   //       ? fileUpload?.data?.firstName
  //   //       : "",
  //   //     lastName: fileUpload?.data?.lastName ? fileUpload?.data?.lastName : "",
  //   //     email: fileUpload?.data?.emailId ? fileUpload?.data?.emailId : "",
  //   //     mobile: fileUpload?.data?.phone ? fileUpload?.data?.phone : "",
  //   //     skillSet: ids.length > 0 ? ids : [],
  //   //   });
  //   //   setErrors({
  //   //     ...errors,
  //   //     firstName: "",
  //   //     lastName: "",
  //   //     email: "",
  //   //     mobile: "",
  //   //   });
  //   // }
  // }, [fileUpload]);

  useEffect(() => {
    if (code && code.length > 0) {
      const list = [];
      code?.map((item) => {
        list.push({
          label: `+${item?.phoneCode}`,
          value: `+${item?.phoneCode}`,
        });
        setPhoneCodeOptionsData(list);
      });
    }
  }, [code]);

  // useEffect(() => {
  //   if (!selectedFile) {
  //     setPreview(undefined)
  //     return
  //   }
  //   const objectUrl = URL.createObjectURL(selectedFile)
  //   setPreview(objectUrl)
  //   return () => URL.revokeObjectURL(objectUrl)
  // }, [selectedFile])

  const getSrcFromFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  };

  const onResumeChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0) {
      // Functional update: this fires again on upload done, and a stale copy
      // of errors would bring back messages addResume just cleared
      setErrors((prev) => ({ ...prev, file: "" }));

      // let type = newFileList[0].originFileObj.name.split(".")[1];
      // setFileType(type);
      // if (type === "pdf") {
      //   const objectUrl = URL.createObjectURL(newFileList[0].originFileObj);
      //   setPreview(objectUrl);
      // }
      //   setFile(newFileList[0].originFileObj);

      //   let formData = new FormData();
      //   formData.append("file", newFileList[0].originFileObj);
      //   await dispatch(addCvDetails(formData));
      //   let payload = new FormData();
      //   payload.append("file", newFileList[0].originFileObj);
      //   payload.append("type", "resume");
      //   // dispatch(candidateFileUpload(payload)).then((res) => {
      //   //   setJobApplicationData({
      //   //     ...jobApplicationData,
      //   //     resume: res?.data?.data?.response,
      //   //   });
      //   // });
    }
  };

  // Last 10 digits, so "+91 98765-43210" becomes "9876543210"
  const normalizePhone = (value) => {
    const digits = String(value || "").replace(/\D/g, "");
    return digits.length > 10 ? digits.slice(-10) : digits;
  };

  // Long degree names mapped to the short forms the qualification list uses
  const degreeAliases = [
    // "Bachelor of Arts", "Bachelor's degree in Arts", "Bachelors (Arts)" all count
    [/bachelor.*\btechnology\b/, "btech"],
    [/bachelor.*\bengineering\b/, "be"],
    [/bachelor.*\bcomputer applications?\b/, "bca"],
    [/bachelor.*\bbusiness administration\b/, "bba"],
    [/bachelor.*\bscience\b/, "bsc"],
    [/bachelor.*\bcommerce\b/, "bcom"],
    [/bachelor.*\barts?\b/, "ba"],
    [/master.*\btechnology\b/, "mtech"],
    [/master.*\bengineering\b/, "me"],
    [/master.*\bcomputer applications?\b/, "mca"],
    [/master.*\bbusiness administration\b/, "mba"],
    [/master.*\bscience\b/, "msc"],
    [/master.*\bcommerce\b/, "mcom"],
    [/master.*\barts?\b/, "ma"],
    [/doctor of philosophy/, "phd"],
    [/higher secondary|\bhsc\b|\b12th\b/, "hsc 12th"],
    [/secondary school|\bssc\b|\b10th\b/, "ssc 10th"],
  ];

  // "B.Tech (CSE)" -> ["btech", "cse"], plus alias tokens for long names
  const degreeTokens = (text) => {
    let value = String(text || "").toLowerCase();
    degreeAliases.forEach(([pattern, alias]) => {
      if (pattern.test(value)) value += ` ${alias}`;
    });
    return value.replace(/\./g, "").split(/[^a-z0-9]+/).filter(Boolean);
  };

  // Higher number = higher degree, so we can pick the highest one held
  const degreeRank = (tokens) => {
    const text = ` ${tokens.join(" ")} `;
    if (/ (phd|doctorate) /.test(text)) return 6;
    if (/ (mtech|me|mca|mba|msc|mcom|ma|master|masters|pg|pgdm|postgraduate|post) /.test(text)) return 5;
    if (/ (btech|be|bca|bba|bsc|bcom|ba|bachelor|bachelors|graduate|graduation|ug|undergraduate) /.test(text)) return 4;
    if (/ diploma /.test(text)) return 3;
    if (/ (hsc|12th) /.test(text)) return 2;
    if (/ (ssc|10th) /.test(text)) return 1;
    return 0;
  };

  // Short code for a degree name: "Bachelor of Arts (English)" and "B.A." both give "ba"
  const degreeCodes = [
    "phd", "mtech", "me", "mca", "mba", "msc", "mcom", "ma", "pgdm",
    "btech", "be", "bca", "bba", "bsc", "bcom", "ba", "diploma", "hsc", "ssc",
  ];
  const degreeCode = (tokens) => degreeCodes.find((code) => tokens.includes(code)) || "";

  // True when every token of the list item appears in order inside the degree
  const containsTokens = (haystack, needle) =>
    needle.length > 0 &&
    haystack.some((_, start) =>
      needle.every((token, i) => haystack[start + i] === token)
    );

  const matchQualification = (educations) => {
    const options = (qualificationDetail?.data || []).map((option) => {
      const tokens = degreeTokens(option.qualification);
      return { option, tokens, code: degreeCode(tokens), rank: degreeRank(tokens) };
    });
    if (!options.length || !Array.isArray(educations)) return null;

    const degrees = educations
      .map((edu) => degreeTokens(`${edu?.degree || ""} ${edu?.major || ""}`))
      .filter((tokens) => tokens.length)
      .sort((a, b) => degreeRank(b) - degreeRank(a));
    const pick = (found) =>
      found ? { label: found.option.qualification, value: found.option._id } : null;

    for (const degree of degrees) {
      const code = degreeCode(degree);
      // 1. List item's words inside the degree, most specific first ("M.Sc IT" over "M.Sc")
      // 2. Same short code, e.g. "Bachelor of Arts" -> "BA"
      const byCode = code && options.find((item) => item.code === code);
      const byWords = options
        .filter((item) => containsTokens(degree, item.tokens))
        .sort((a, b) => b.tokens.length - a.tokens.length)[0];
      if (byWords || byCode) return pick(byWords || byCode);
    }
    // 3. Same level, e.g. any bachelor's degree -> "Graduate"
    const topRank = degrees.length ? degreeRank(degrees[0]) : 0;
    return topRank ? pick(options.find((item) => !item.code && item.rank === topRank)) : null;
  };

  // Every skill the parser read, as chips: master skills first, then new ones.
  // New ones are only created in the skill master on submit, see createNewSkills
  const resolveSkills = (cv) => {
    const chips = (cv.candidateSkillSet || [])
      .filter((item) => item._id)
      .map((item) => ({ value: item._id, label: item.skill }));
    const has = (name) =>
      chips.some((chip) => chip.label.toLowerCase() === name.toLowerCase());
    const master = Array.isArray(skillDetail) ? skillDetail : [];
    const missing = [];

    (cv.rawSkills || []).forEach((raw) => {
      const name = String(raw || "").trim();
      if (!name || name.length > 60 || has(name)) return;
      const known = master.find(
        (item) => String(item.skill).toLowerCase() === name.toLowerCase()
      );
      if (known) chips.push({ value: known._id, label: known.skill });
      else if (!missing.some((item) => item.toLowerCase() === name.toLowerCase()))
        missing.push(name);
    });

    missing.forEach((name) =>
      chips.push({ value: NEW_SKILL_PREFIX + name, label: name })
    );
    return chips;
  };

  // Swap "new:<name>" skill values for real ids, creating those skills now
  const createNewSkills = async (skillSet) => {
    const ids = await Promise.all(
      skillSet.map(async (value) => {
        if (!String(value).startsWith(NEW_SKILL_PREFIX)) return value;
        const created = await createResumeSkill(value.slice(NEW_SKILL_PREFIX.length));
        return created?._id || null;
      })
    );
    return ids.filter(Boolean);
  };

  // Country names from the resume must match the country list exactly
  const matchCountry = (name) => {
    const wanted = String(name || "").trim().toLowerCase();
    if (!wanted) return "";
    const aliases = { usa: "united states", us: "united states", uk: "united kingdom", uae: "united arab emirates" };
    const target = aliases[wanted] || wanted;
    const found = (countryList || []).find(
      (country) => String(country.countryName || "").toLowerCase() === target
    );
    return found ? found.countryName : "";
  };

  const clearErrors = () =>
    setErrors((prev) =>
      Object.fromEntries(
        Object.keys(prev).map((key) => [key, Array.isArray(prev[key]) ? [] : ""])
      )
    );

  // Form sections show a skeleton until both resume calls are done
  const addResume = async (resume) => {
    // A new resume refills the form, so earlier "required" messages go away
    clearErrors();
    setParsingResume(true);
    try {
      await readResume(resume);
    } finally {
      setParsingResume(false);
    }
  };

  const readResume = async (resume) => {
    const application = applicationRef.current;
    let type = resume.name.split(".").pop().toLowerCase();
    setFileType(type);

    if (["pdf", "docx", "jpg", "jpeg", "png"].includes(type)) {
      const objectUrl = URL.createObjectURL(resume);
      setPreview(objectUrl);
    }
    setFile(resume);

    let parsed = {};
    let formData = new FormData();
    formData.append("file", resume);
    const res = await dispatch(addCvDetails(formData));
    const cv = res?.data?.status === 1 ? res?.data?.data : null;

    if (cv) {
      const skillChips = resolveSkills(cv);
      if (skillChips.length) setSelectedSkill(skillChips);

      // Older parser responses only have "currentLocation", e.g. "Ahmedabad, Gujarat, India"
      const location = (cv.currentLocation || "").split(",").map((part) => part.trim());
      const notice = noticePeriod.find(
        (option) =>
          option.value.toLowerCase() === String(cv.noticePeriod || "").toLowerCase()
      );
      const qualification = matchQualification(cv.educations);

      parsed = {
        firstName: cv.firstName || "",
        lastName: cv.lastName || "",
        email: cv.emailId || "",
        mobile: normalizePhone(cv.mobile || cv.phone),
        currentEmployer: cv.currentEmployer || "",
        totalExperiance:
          Number(cv.totalExperiance) > 0 ? String(cv.totalExperiance) : "",
        currentSalary:
          Number(cv.currentSalary) > 0 ? String(cv.currentSalary) : "",
        noticePeriod: notice || "",
        qualificationId: qualification || "",
        qualification: qualification || "",
        skillSet: skillChips.map((item) => item.value),
        street: cv.street || "",
        zipCode: String(cv.zipCode || "").replace(/\D/g, ""),
        city: cv.city || location[0] || "",
        state: cv.state || (location.length > 2 ? location[1] : ""),
        country: matchCountry(cv.country || location[location.length - 1]),
      };
      // Drop anything the parser couldn't find so typed values survive
      Object.keys(parsed).forEach((key) => {
        const value = parsed[key];
        if (value === "" || (Array.isArray(value) && value.length === 0)) {
          delete parsed[key];
        }
      });

      setErrors((prev) => {
        const next = { ...prev };
        Object.keys(parsed).forEach((key) => {
          next[key] = "";
        });
        return next;
      });
    }

    let payload = new FormData();
    payload.append("file", resume);
    payload.append("type", "resume");
    const uploadRes = await dispatch(candidateFileUpload(payload));

    // The candidate went back while this was running; drop the result
    if (applicationRef.current !== application) {
      const path = uploadRes?.data?.data?.response;
      path && dispatch(candidateFileDelete({ type: "resume", filePath: path }));
      return;
    }

    const experiences = parsedExperiences(cv?.experiences);
    const educations = parsedEducations(cv?.educations);
    experiences.length && setExperienceDetails(experiences);
    educations.length && setEducationDetails(educations);

    setJobApplicationData((prev) => ({
      ...prev,
      ...parsed,
      // Mobile is shown as phoneCode + number, so give it a code to sit behind
      phoneCode: parsed.mobile && !prev.phoneCode ? "91" : prev.phoneCode,
      resume: uploadRes?.data?.data?.response,
    }));

    showSuccessToast("Resume/CV added successfully");
    if (
      !cv ||
      (Object.keys(parsed).length === 0 && !experiences.length && !educations.length)
    ) {
      showErrorToast(
        "We couldn't read details from this resume. Please fill them in."
      );
    }
  };

  // The upload API only returns the storage key, so build the full file URL
  const resumeFileUrl = (path) =>
    !path || /^https?:\/\//.test(path) ? path : `${REACT_APP_FILE_UPLOAD}${path}`;

  // PDFs and images preview from the picked file itself; Word files go through
  // the Office viewer, which needs the uploaded file's public URL
  const resumePreviewUri = ["doc", "docx"].includes(fileType)
    ? resumeFileUrl(jobApplicationData.resume)
    : preview || resumeFileUrl(jobApplicationData.resume);

  // "206.3 KB" / "1.2 MB"
  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const resumeIcon = (type) => {
    if (type === "pdf") return "bxs-file-pdf";
    if (type === "doc" || type === "docx") return "bxs-file-doc";
    return "bxs-file-image";
  };

  const chooseReplaceMode = (mode) => {
    replaceModeRef.current = mode;
    setShowReplaceResume(false);
    replaceInputRef.current?.click();
  };

  // Swap only the stored file; the form keeps everything typed so far
  const replaceResumeFile = async (resume) => {
    const type = resume.name.split(".").pop().toLowerCase();
    setFileType(type);
    setPreview(
      ["pdf", "docx", "jpg", "jpeg", "png"].includes(type)
        ? URL.createObjectURL(resume)
        : ""
    );
    setFile(resume);
    let payload = new FormData();
    payload.append("file", resume);
    payload.append("type", "resume");
    const uploadRes = await dispatch(candidateFileUpload(payload));
    setJobApplicationData((prev) => ({
      ...prev,
      resume: uploadRes?.data?.data?.response,
    }));
    showSuccessToast("Resume replaced.");
  };

  const onReplaceFileChosen = (e) => {
    const resume = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!resume) return;
    if (jobApplicationData.resume) {
      dispatch(
        candidateFileDelete({ type: "resume", filePath: jobApplicationData.resume })
      );
    }
    if (replaceModeRef.current === "full") {
      clearProfileData();
      addResume(resume);
    } else replaceResumeFile(resume);
  };

  // "Resume + profile data" starts the form over; the photo stays
  const clearProfileData = () => {
    setSelectedSkill([]);
    setExperienceDetails([emptyExperience()]);
    setEducationDetails([emptyEducation()]);
    setJobApplicationData((prev) => ({
      ...prev,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: [],
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      qualificationId: "",
      qualification: "",
    }));
  };

  const handleReupload = () => {
    setFile();
    setPreview("");
    setFileList([]);
    setFileType("");

    // Clear ALL validation errors — form data is wiped so stale
    // "field is required" messages must not stay on screen
    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: "",
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      qualificationId: "",
      qualification: "",
      succsessFile: "",
      file: "",
    });

    // Removing the resume clears everything it filled in; the photo stays
    setSelectedSkill([]);
    setExperienceDetails([emptyExperience()]);
    setEducationDetails([emptyEducation()]);
    let deletePayload = {
      type: "resume",
      filePath: jobApplicationData.resume,
    };
    jobApplicationData.resume && dispatch(candidateFileDelete(deletePayload));
    setJobApplicationData((prev) => ({
      ...prev,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: [],
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      resume: "",
      qualificationId: "",
      qualification: "",
    }));
  };

  const handleImageReupload = () => {
    setImage();
    // setPreview("");
    setProfileList([]);
    // setFileType("");
    setErrors({
      ...errors,
      successImageFile: "",
      // file: "",
    });

    let payload = {
      type: "photo",
      filePath: jobApplicationData.photo,
    };
    dispatch(candidateFileDelete(payload));
    setJobApplicationData({
      ...jobApplicationData,
      photo: "",
    });
  };

  const onPreview = async (file) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);

    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  // Ticking "currently pursuing / working" ends the entry at this month
  const updateEntry = (list, index, name, value, currentKey) =>
    list.map((item, i) =>
      i !== index
        ? item
        : {
          ...item,
          [name]: value,
          ...(name === currentKey && value
            ? { to: moment().format(MONTH_FORMAT) }
            : {}),
        }
    );

  const handleEducationDetails = (value, index, name) =>
    setEducationDetails((list) => updateEntry(list, index, name, value, "pursuing"));

  const handleExpDetail = (value, index, name) =>
    setExperienceDetails((list) => updateEntry(list, index, name, value, "isWorking"));

  const handleAddEducation = () =>
    setEducationDetails((list) => [...list, emptyEducation()]);

  const handleExeperienceAdd = () =>
    setExperienceDetails((list) => [...list, emptyExperience()]);

  // The last entry is emptied rather than removed, so the section keeps its fields
  const handleRemoveEducation = (index) =>
    setEducationDetails((list) =>
      list.length > 1 ? list.filter((_, i) => i !== index) : [emptyEducation()]
    );

  const handleRemoveExperience = (index) =>
    setExperienceDetails((list) =>
      list.length > 1 ? list.filter((_, i) => i !== index) : [emptyExperience()]
    );

  // Resume parser entries in the shape the form keeps
  const parsedExperiences = (items) =>
    (Array.isArray(items) ? items : [])
      .map((item) => ({
        occupation: String(item?.occupation || "").trim(),
        company: String(item?.company || "").trim(),
        summary: String(item?.summary || "").trim(),
        from: normalizeMonth(item?.from),
        to: isPresent(item?.to) ? moment().format(MONTH_FORMAT) : normalizeMonth(item?.to),
        isWorking: !!item?.isWorking || isPresent(item?.to),
      }))
      .filter((item) => hasText(item, EXPERIENCE_KEYS));

  const parsedEducations = (items) =>
    (Array.isArray(items) ? items : [])
      .map((item) => ({
        institute: String(item?.institute || "").trim(),
        major: String(item?.major || "").trim(),
        degree: String(item?.degree || "").trim(),
        from: normalizeMonth(item?.from),
        to: isPresent(item?.to) ? moment().format(MONTH_FORMAT) : normalizeMonth(item?.to),
        pursuing: !!item?.pursuing || isPresent(item?.to),
      }))
      .filter((item) => hasText(item, EDUCATION_KEYS));

  const validateForm = () => {
    let isFormValid = true;
    let error = {
      firstName: "",
      // phoneCode: "",
      lastName: "",
      email: "",
      mobile: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      city: "",
      qualification: "",
      country: "",
      noticePeriod: "",
      file: "",
      skillSet: "",
    };
    let mobileRegex = "^[0-9][0-9]{9,12}$";
    let emailRegex =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // if (!file) {
    //   error.file = "Please upload resume";
    //   // setErrors(error);
    //   swal({
    //     title: "Please upload Resume/CV first",
    //     icon: "warning",
    //     // buttons: true,
    //     dangerMode: true,
    //   }).then(function (isConfirm) {
    //     if (isConfirm) {
    //     }
    //   });
    //   isFormValid = false;

    //   return isFormValid;
    // } else {
    // error.file = "";

    if (!file) {
      error.file = "Resume/CV is required";
    } else error.file = "";

    if (jobApplicationData.firstName === "") {
      error.firstName = "First name is required";
    } else error.firstName = "";

    if (jobApplicationData.lastName === "") {
      error.lastName = "Last name is required";
    } else error.lastName = "";

    if (jobApplicationData.email === "") {
      error.email = "Email is required";
    } else if (!new RegExp(emailRegex).test(jobApplicationData.email)) {
      error.email = "Please provide a valid email";
    } else error.email = "";

    // if (jobApplicationData.phoneCode === "") {
    // 	error.phoneCode = "Country Code &";
    // } else error.phoneCode = "";

    if (jobApplicationData.mobile === "") {
      error.mobile = "Mobile number is required";
    } else if (!new RegExp(mobileRegex).test(jobApplicationData.mobile)) {
      error.mobile = "Mobile number in between 10-13 digits";
    } else error.mobile = "";

    if (jobApplicationData.currentEmployer === "") {
      error.currentEmployer = "This field is required.";
    } else error.currentEmployer = "";

    if (jobApplicationData.totalExperiance === "") {
      error.totalExperiance = "This field is required.";
    } else error.totalExperiance = "";

    if (jobApplicationData.currentSalary === "") {
      error.currentSalary = "This field is required.";
    } else error.currentSalary = "";
    if (jobApplicationData.noticePeriod === "") {
      error.noticePeriod = "This field is required.";
    } else error.noticePeriod = "";
    if (jobApplicationData.city === "") {
      error.city = "This field is required.";
    } else error.city = "";

    if (jobApplicationData.qualificationId === "") {
      error.qualification = "This field is required";
    } else error.qualification = "";
    if (jobApplicationData.country === "") {
      error.country = "This field is required";
    } else error.country = "";
    if (jobApplicationData.skillSet.length === 0) {
      error.skillSet = "This field is required";
    } else error.skillSet = "";
    if (
      error.file !== "" ||
      error.firstName !== "" ||
      error.lastName !== "" ||
      error.email !== "" ||
      // error.phoneCode !== "" ||
      error.mobile !== "" ||
      error.currentEmployer !== "" ||
      error.totalExperiance !== "" ||
      error.currentSalary !== "" ||
      error.qualification !== "" ||
      error.city !== "" ||
      error.country !== "" ||
      error.noticePeriod !== "" ||
      error.skillSet !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(error);
    return { isFormValid, error };
    //  }
  };

  // Scroll to the first form section that has a validation error
  // Bumped on a failed submit; the effect below runs once the messages are on screen
  const [errorScrollKey, setErrorScrollKey] = useState(0);
  const scrollToFirstError = () => setErrorScrollKey((key) => key + 1);

  // Wizard: a new step starts at the top of the form. Declared before the error
  // effect so a failed submit still ends on the field, not the top.
  const mainRef = useRef(null);
  const stepMounted = useRef(false);
  useEffect(() => {
    if (!stepMounted.current) {
      stepMounted.current = true;
      return;
    }
    const main = mainRef.current;
    if (!main) return;
    // Keep the active step in view when the wizard row scrolls sideways (small screens)
    const wizard = main.querySelector(".nic-wizard");
    const current = wizard && wizard.querySelector("li.is-active");
    if (current && wizard.scrollWidth > wizard.clientWidth) {
      wizard.scrollTo({
        left: current.offsetLeft - (wizard.clientWidth - current.clientWidth) / 2,
        behavior: "smooth",
      });
    }
    if (main.scrollHeight > main.clientHeight) {
      main.scrollTo({ top: 0, behavior: "smooth" }); // desktop: the form column scrolls
    } else {
      // small screens: the page scrolls, the sidebar sits above the form
      window.scrollTo({ top: main.getBoundingClientRect().top + window.scrollY, behavior: "smooth" });
    }
  }, [activeStep]);

  // First visible message in page order (other steps are hidden)
  useEffect(() => {
    if (!errorScrollKey) return;
    const message = Array.from(
      document.querySelectorAll(".nic-jobdetails .error-msg")
    ).find((item) => item.textContent.trim() !== "" && item.offsetParent !== null);
    if (!message) return;
    const field = message.closest(".form-group") || message.parentElement;
    field.scrollIntoView({ behavior: "smooth", block: "center" });
    field.querySelector("input, textarea")?.focus({ preventScroll: true });
  }, [errorScrollKey]);

  // Other steps stay locked until a resume is added and its details are read
  const stepsLocked = !file || parsingResume;

  const goToStep = (index) => {
    if (stepsLocked && index !== activeStep) return;
    setActiveStep(Math.min(Math.max(index, 0), LAST_STEP));
  };

  // "Next" only checks the current step's required fields
  const goNext = () => {
    const keys = STEP_REQUIRED[STEP_KEYS[activeStep]] || [];
    if (keys.length) {
      const before = errors;
      const { error } = validateForm();
      // Show messages for this step only; later steps stay untouched until reached
      setErrors({ ...before, ...Object.fromEntries(keys.map((key) => [key, error[key] || ""])) });
      if (keys.some((key) => error[key])) {
        scrollToFirstError();
        return;
      }
    }
    goToStep(activeStep + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Enter in a field before the last step behaves like "Next"
    if (activeStep < LAST_STEP) {
      goNext();
      return;
    }
    const { isFormValid, error } = validateForm();
    if (!isFormValid) {
      // Open the first step that has a missing field (the resume comes first),
      // then scroll to it
      const firstBad = error.file
        ? STEP_KEYS.indexOf("upload")
        : STEP_KEYS.findIndex((key) =>
          (STEP_REQUIRED[key] || []).some((field) => error[field])
        );
      if (firstBad >= 0) setActiveStep(firstBad);
      scrollToFirstError();
      return;
    }
    if (isFormValid) {
      let files = [];
      if (file) files.push({ name: "resume", item: file });
      if (image) files.push({ name: "photo", item: image });
      setUploadList(files);

      setIsLoading(true);
      let list = [];
      jobApplicationData.skillSet.map((item) => list.push(item.value));
      const skillSet = await createNewSkills(jobApplicationData.skillSet);

      let obj = {
        postingTitle: [jobData._id],
        firstName: jobApplicationData.firstName,
        lastName: jobApplicationData.lastName,
        emailId: jobApplicationData.email,
        phoneCode: jobApplicationData.phoneCode,
        mobile: jobApplicationData.mobile,
        noticePeriod: jobApplicationData.noticePeriod.value,
        currentEmployer: jobApplicationData.currentEmployer,
        totalExperiance: jobApplicationData.totalExperiance,
        currentSalary: jobApplicationData.currentSalary,
        skillSet,
        // Blank cards are left out
        educations: educationDetails.filter((item) => hasText(item, EDUCATION_KEYS)),
        experiences: experienceDetails.filter((item) => hasText(item, EXPERIENCE_KEYS)),
        street: jobApplicationData.street,
        zipCode: jobApplicationData.zipCode,
        city: jobApplicationData.city,
        state: jobApplicationData.state,
        country: jobApplicationData.country,
        qualification: jobApplicationData.qualificationId.value,
        resume: jobApplicationData.resume,
        photo: jobApplicationData.photo,
        recruiterName: jobData.assignedRecruiters,
        createdForm: "webForm",
      };
      // A failed or timed-out request must not leave the loader on
      try {
        await dispatch(addCandidateData(obj));
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleChange = async (file) => {
    if (file) {
      setErrors({
        ...errors,
        succsessFile: "File added succsessfully",
        file: "",
      });
    }
    let type = file.name.split(".")[1];
    if (
      type === "pdf" ||
      type === "docx" ||
      type === "jpg" ||
      type === "jpeg"
    ) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
    }
    setFile(file);
    setSelectedFile(file);
    let formData = new FormData();
    formData.append("file", file);
    await dispatch(addCvDetails(formData));
  };

  const handleImageChange = async ({ fileList }) => {
    // "Upload new" adds to the list, only the latest picture counts
    const newFileList = fileList.slice(-1);
    if (newFileList.length > 0) {
      setProfileList(newFileList);
    }
    setImage(newFileList[0]?.originFileObj);

    // let payload = new FormData();
    // payload.append("file", newFileList[0].originFileObj);
    // payload.append("type", "photo");
    // dispatch(candidateFileUpload(payload)).then((res) => {
    //   setJobApplicationData({
    //     ...jobApplicationData,
    //     photo: res?.data?.data?.response,
    //   });
    // });
  };

  // Picked or captured photo, drawn straight into the avatar circle
  const photoUrl = useMemo(() => (image ? URL.createObjectURL(image) : ""), [image]);
  useEffect(() => () => photoUrl && URL.revokeObjectURL(photoUrl), [photoUrl]);

  const addProfile = async (profile) => {
    // A replaced picture shouldn't stay behind on the server
    if (jobApplicationData.photo) {
      dispatch(
        candidateFileDelete({ type: "photo", filePath: jobApplicationData.photo })
      );
    }
    let payload = new FormData();
    payload.append("file", profile);
    payload.append("type", "photo");
    dispatch(candidateFileUpload(payload)).then((res) => {
      setJobApplicationData((prev) => ({
        ...prev,
        photo: res?.data?.data?.response,
      }));
      if (res?.data?.data?.response) showSuccessToast("Image added successfully");
    });
  };

  const previewPhoto = () => {
    setShowPhotoMenu(false);
    setShowPhotoPreview(true);
  };

  const removePhoto = () => {
    setShowPhotoMenu(false);
    handleImageReupload();
  };

  // While the application form is open only its own column scrolls, so the page
  // itself is locked even if something else (extensions, overlays) adds height
  useEffect(() => {
    if (!interested) return;
    // "Apply Here" sits low on a long description; don't lock the page mid-scroll
    window.scrollTo(0, 0);
    document.body.classList.add("nic-form-open");
    return () => document.body.classList.remove("nic-form-open");
  }, [interested]);

  // Close the Capture / Upload menu on any click outside it
  useEffect(() => {
    if (!showPhotoMenu) return;
    const close = (e) => {
      if (!e.target.closest(".nic-photo-menu, .nic-avatar-trigger")) {
        setShowPhotoMenu(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [showPhotoMenu]);

  // Start the webcam while the capture popup is open, stop it when it closes
  useEffect(() => {
    if (!showCamera) return;
    let cancelled = false;
    if (!navigator.mediaDevices?.getUserMedia) {
      setCameraError("Camera is not supported in this browser.");
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "user" }, audio: false })
      .then((stream) => {
        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
      })
      .catch(() =>
        setCameraError(
          "Couldn't open the camera. Please allow camera access, or upload a photo instead."
        )
      );
    return () => {
      cancelled = true;
      streamRef.current?.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    };
  }, [showCamera]);

  const openPhotoUpload = () => {
    setShowPhotoMenu(false);
    avatarRef.current?.querySelector('input[type="file"]')?.click();
  };

  const openCamera = () => {
    setShowPhotoMenu(false);
    setCapturedPhoto("");
    setCameraError("");
    setShowCamera(true);
  };

  // Square snapshot from the middle of the video frame
  const takePhoto = () => {
    const video = videoRef.current;
    if (!video || !video.videoWidth) return;
    const size = Math.min(video.videoWidth, video.videoHeight);
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    canvas
      .getContext("2d")
      .drawImage(
        video,
        (video.videoWidth - size) / 2,
        (video.videoHeight - size) / 2,
        size,
        size,
        0,
        0,
        size,
        size
      );
    setCapturedPhoto(canvas.toDataURL("image/jpeg", 0.9));
  };

  // Hand the snapshot to the same flow as an uploaded picture
  const applyCapturedPhoto = async () => {
    const blob = await (await fetch(capturedPhoto)).blob();
    const name = `profile-${Date.now()}.jpg`;
    const photo = new File([blob], name, { type: "image/jpeg" });
    setProfileList([
      {
        uid: `capture-${Date.now()}`,
        name,
        status: "done",
        url: capturedPhoto,
        thumbUrl: capturedPhoto,
        originFileObj: photo,
      },
    ]);
    setImage(photo);
    addProfile(photo);
    setShowCamera(false);
  };

  const handleDataChange = (e, type) => {
    if (type === "num") {
      setJobApplicationData({
        ...jobApplicationData,
        [e.target.name]: e.target.value,
      });
    } else if (type === "email") {
      setJobApplicationData({
        ...jobApplicationData,
        [e.target.name]: emailValidator(e.target.value),
      });
    } else {
      setJobApplicationData({
        ...jobApplicationData,
        [e.target.name]: textValidator(e.target.value),
      });
    }
  };

  const getSkillSetList = (searchText) => {
    clearTimeout(timeOut.current);
    timeOut.current = setTimeout(async () => {
      if (searchText !== "") {
        await dispatch(getSkillDetails(searchText));
      } else {
        setSkillSetOption(null);
      }
    }, 600);
  };

  // Back to the job description: the next "Apply Here" starts from a blank form,
  // and files uploaded for this unsent application are removed from the server
  const leaveApplication = () => {
    applicationRef.current += 1;
    setParsingResume(false);
    if (jobApplicationData.resume) {
      dispatch(candidateFileDelete({ type: "resume", filePath: jobApplicationData.resume }));
    }
    if (jobApplicationData.photo) {
      dispatch(candidateFileDelete({ type: "photo", filePath: jobApplicationData.photo }));
    }
    resetData();
    // resetData leaves these keys out of the form object
    setJobApplicationData((prev) => ({ ...prev, phoneCode: "", resume: "", photo: "" }));
    clearErrors();
    setActiveStep(0);
    setFile();
    setPreview("");
    setFileList([]);
    setFileType("");
    setImage();
    setProfileList([]);
    setShowPhotoMenu(false);
    setShowReplaceResume(false);
    setShowPreview(false);
  };

  const resetData = () => {
    setIsLoading(false);
    setJobApplicationData({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      // phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: [],
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      qualificationId: "",
      qualification: "",
    });
    setSelectedSkill([]);
    setJobSuccess(false);
    setInterested(false);
    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      // phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: "",
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      qualificationId: "",
      qualification: "",
    });
    setShow(false);
    setEducationDetails([
      {
        institute: "",
        major: "",
        degree: "",
        from: "",
        to: "",
        pursuing: false,
      },
    ]);
    setExperienceDetails([
      {
        occupation: "",
        company: "",
        summary: "",
        from: "",
        to: "",
        isWorking: false,
      },
    ]);
    setFile();
    setPreview("");
    setFileList([]);
    setFileType("");
    setErrors({
      ...errors,
      succsessFile: "",
      successImageFile: "",
      file: "",
    });
    setImage();
    setProfileList([]);
  };

  const fileTypes = ["PDF", "DOC", "DOCX", "JPG", "JPEG", "PNG"];

  var noticePeriod = [
    "Immediately",
    "15 Days",
    "30 Days",
    "45 Days",
    "60 Days",
    "90 Days",
  ].map(function (notperiod) {
    return { label: notperiod, value: notperiod };
  });

  const handleClose = () => {
    setShow(false);
    resetData();
  };
  // const formatPhoneNumber = (phoneNumber, country) => {
  //   if (!phoneNumber || !country) return phoneNumber;

  //   const reducedPhone = phoneNumber.replace(country.dialCode, "");
  //   const formattedPhone = `+${country.dialCode}-${reducedPhone}`;

  //   return formattedPhone;
  // };
  const formatPhoneNumber = async (phoneNumber, country) => {
    const reducedPhone = phoneNumber.replace(country.dialCode, "");

    setJobApplicationData({
      ...jobApplicationData,
      mobile: reducedPhone,
      phoneCode: country.dialCode,
    });
  };
  const renderPreview = useMemo(() => {
    if (fileType === "pdf") {
      return <iframe src={preview} />;
    } else if (!showPreview) {
      return (
        <DocViewer
          documents={[
            {
              uri: jobApplicationData?.resume,
              fileType: fileType,
            },
          ]}
          pluginRenderers={[
            PDFRenderer,
            MSDocRenderer,
            PNGRenderer,
            JPGRenderer,
          ]}
          theme={{
            primary: "#5296d8",
            secondary: "#00000099",
            tertiary: "#5296d899",
            text_primary: "#ffffff",
            text_secondary: "#5296d8",
            text_tertiary: "#00000099",
            disableThemeScrollbar: false,
          }}
        />
      );
    }

    // Default case or other conditions if needed
    return null;
  }, [preview, fileType, showPreview, jobApplicationData.resume]);

  // A step is ticked only when every one of its required fields has a value
  // and none of them is showing an error
  const isStepComplete = (key) =>
    STEP_REQUIRED[key].every((field) => {
      const value = jobApplicationData[field];
      const filled = Array.isArray(value) ? value.length > 0 : !!String(value ?? "").trim();
      return filled && !errors[field];
    });

  // Wizard steps (same order as STEP_KEYS)
  const formSteps = [
    { id: "nic-upload", label: "Upload documents", done: !!file },
    { id: "nic-basic", label: "Basic info", done: isStepComplete("basic") },
    {
      id: "nic-professional",
      label: "Professional details",
      done: isStepComplete("professional"),
    },
    {
      id: "nic-experience",
      label: "Experience details",
      optional: true,
      done: experienceDetails.some((item) => hasText(item, EXPERIENCE_KEYS)),
    },
    {
      id: "nic-education",
      label: "Education details",
      optional: true,
      done: educationDetails.some((item) => hasText(item, EDUCATION_KEYS)),
    },
    {
      id: "nic-address",
      label: "Address details",
      done: isStepComplete("address"),
    },
  ];
  const showSteps = !jobSuccess;

  // Success popup data (response of the apply call)
  const successData = addJob?.data;
  const successContact = successData?.generalContact;
  const thankYouMsg = successContact?.thankYouMsg;
  // Only use the admin message when it has real text, not just "- -" or empty tags
  const hasThankYouMsg = /[a-z]/i.test(String(thankYouMsg || "").replace(/<[^>]*>/g, ""));

  // Horizontal wizard above the form; any step can be opened by clicking it
  const renderWizard = () => (
    <nav className={`nic-wizard ${parsingResume ? "is-reading" : ""}`} aria-label="Application steps">
      <ol>
        {formSteps.map((step, index) => {
          const active = index === activeStep;
          const locked = stepsLocked && !active;
          return (
            <li
              key={step.id}
              className={`${active ? "is-active" : ""} ${step.done ? "is-done" : ""} ${locked ? "is-locked" : ""}`}
            >
              <button
                type="button"
                aria-current={active ? "step" : undefined}
                disabled={locked}
                title={locked && !parsingResume ? "Upload your resume to continue" : undefined}
                onClick={() => goToStep(index)}
              >
                <span className="nic-wizard-dot">
                  {/* Spinner while the resume is being read */}
                  {parsingResume && !active ? (
                    <span className="bx bx-loader-alt bx-spin"></span>
                  ) : step.done && !active ? (
                    <span className="bx bx-check"></span>
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="nic-wizard-label">
                  {step.label}
                  {step.optional && (
                    <span className="nic-wizard-optional">(optional)</span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );

  const renderSectionHeader = (key, id, badge, title) => (
    <div className={`panel-header ${isStepActive(key) ? "" : "d-none"}`} id={id}>
      <h4 className="nic-section-title">
        <span className="nic-section-badge">{badge}</span>
        {title}
      </h4>
    </div>
  );

  // Section body: shown only on its step, swapped for a skeleton while the resume is read
  const sectionClass = (key) =>
    `panel-content py-0 ${!isStepActive(key) || parsingResume ? "d-none" : ""}`;

  // From / To month pickers shared by experience and education cards
  const renderMonthRange = (item, index, idPrefix, onChange, currentKey, currentLabel) => (
    <Row>
      <Col xs={"6"}>
        <Form.Group>
          <Form.Label htmlFor={`${idPrefix}From${index}`}>From</Form.Label>
          <DatePicker
            id={`${idPrefix}From${index}`}
            className="form-control"
            selected={toMonthDate(item.from)}
            onChange={(date) =>
              onChange(date ? moment(date).format(MONTH_FORMAT) : "", index, "from")
            }
            dateFormat="MM/yyyy"
            placeholderText="MM/YYYY"
            showMonthYearPicker
            maxDate={new Date()}
          />
        </Form.Group>
      </Col>
      <Col xs={"6"}>
        <Form.Group>
          <Form.Label htmlFor={`${idPrefix}To${index}`}>To</Form.Label>
          <DatePicker
            id={`${idPrefix}To${index}`}
            className="form-control"
            selected={toMonthDate(item.to)}
            onChange={(date) =>
              onChange(date ? moment(date).format(MONTH_FORMAT) : "", index, "to")
            }
            dateFormat="MM/yyyy"
            placeholderText="MM/YYYY"
            showMonthYearPicker
            minDate={toMonthDate(item.from)}
            maxDate={new Date()}
            disabled={item[currentKey]}
          />
        </Form.Group>
      </Col>
      <Col xs={"12"}>
        <Form.Check
          type="checkbox"
          id={`${idPrefix}Current${index}`}
          className="nic-entry-check"
          label={currentLabel}
          checked={!!item[currentKey]}
          onChange={(e) => onChange(e.target.checked, index, currentKey)}
        />
      </Col>
    </Row>
  );

  const renderEntryHead = (title, item, keys, list, onRemove, index) => (
    <div className="nic-entry-head">
      <span className="nic-entry-title">
        {title} {index + 1}
      </span>
      {(list.length > 1 || hasText(item, keys)) && (
        <button type="button" className="nic-entry-remove" onClick={() => onRemove(index)}>
          <span className="bx bx-trash"></span> Remove
        </button>
      )}
    </div>
  );

  const renderExperience = (item, index) => (
    <div className="nic-entry" key={index}>
      {renderEntryHead("Experience", item, EXPERIENCE_KEYS, experienceDetails, handleRemoveExperience, index)}
      <Row>
        <Col md={"4"} sm={"6"}>
          <Form.Group controlId={`expOccupation${index}`}>
            <Form.Label>Job Title</Form.Label>
            <Form.Control
              type="text"
              maxLength="60"
              value={item.occupation}
              onChange={(e) => handleExpDetail(e.target.value, index, "occupation")}
            />
          </Form.Group>
        </Col>
        <Col md={"4"} sm={"6"}>
          <Form.Group controlId={`expCompany${index}`}>
            <Form.Label>Company</Form.Label>
            <Form.Control
              type="text"
              maxLength="60"
              value={item.company}
              onChange={(e) => handleExpDetail(e.target.value, index, "company")}
            />
          </Form.Group>
        </Col>
        <Col md={"4"} sm={"12"}>
          {renderMonthRange(item, index, "exp", handleExpDetail, "isWorking", "I currently work here")}
        </Col>
        <Col xs={"12"}>
          <Form.Group controlId={`expSummary${index}`}>
            <Form.Label>Summary</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              maxLength="500"
              value={item.summary}
              onChange={(e) => handleExpDetail(e.target.value, index, "summary")}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );

  const renderEducation = (item, index) => (
    <div className="nic-entry" key={index}>
      {renderEntryHead("Education", item, EDUCATION_KEYS, educationDetails, handleRemoveEducation, index)}
      <Row>
        <Col md={"4"} sm={"6"}>
          <Form.Group controlId={`eduDegree${index}`}>
            <Form.Label>Degree</Form.Label>
            <Form.Control
              type="text"
              maxLength="60"
              value={item.degree}
              onChange={(e) => handleEducationDetails(e.target.value, index, "degree")}
            />
          </Form.Group>
        </Col>
        <Col md={"4"} sm={"6"}>
          <Form.Group controlId={`eduMajor${index}`}>
            <Form.Label>Major / Specialization</Form.Label>
            <Form.Control
              type="text"
              maxLength="60"
              value={item.major}
              onChange={(e) => handleEducationDetails(e.target.value, index, "major")}
            />
          </Form.Group>
        </Col>
        <Col md={"4"} sm={"12"}>
          <Form.Group controlId={`eduInstitute${index}`}>
            <Form.Label>Institute</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              value={item.institute}
              onChange={(e) => handleEducationDetails(e.target.value, index, "institute")}
            />
          </Form.Group>
        </Col>
        <Col md={"4"} sm={"12"}>
          {renderMonthRange(item, index, "edu", handleEducationDetails, "pursuing", "Currently pursuing")}
        </Col>
      </Row>
    </div>
  );

  return (
    <React.Fragment>
      {!interested ? (
        <>
          <Container className="jd-orange">
            <header
              className="consultant-header d-block"
            // style={{ backgroundImage: `url(${bgImg})` }}
            >
              <Image
                src={inicLogo}
                width="140"
                height="140"
                alt="IndiaNIC Infotech Pvt. Ltd."
                className="inic-logo"
              />
              <div className="my-5">
                <h4 className="text-primary mb-0">Apply for</h4>
                <h1 className="text-dark display-4 font-weight-bold">
                  {jobData && jobData.title}
                </h1>
              </div>
            </header>
            {!interested && (
              <div className="jd-body-panel ">
                <React.Fragment>
                  <Row>
                    <Col md="9">
                      <div className="panel">
                        <div className="panel-content pb-0">
                          <h3 className="title text-gray mb-2">Job Description</h3>
                          <section
                            className="job-description-content"
                            dangerouslySetInnerHTML={{
                              __html: jobData && jobData.description,
                            }}
                          />
                        </div>
                        <hr />
                        <div className="jdp-jobdescription panel-content pt-0">
                          <h3 className="title text-gray mb-3">About us</h3>
                          <h4 className="sub-title">About IndiaNIC</h4>
                          <p>
                            With a talented team of 550+ engineers, project managers
                            and leaders, we excel in providing top-notch award
                            winning solutions. Seeing the clients passionate about
                            their idea makes us excited. We always look for new ways
                            to provide solutions and create a better product.
                          </p>

                          <p className="mb-2 text-primary">We work on - </p>

                          <h4 className="sub-title">WEB DEVELOPMENT</h4>
                          <p>
                            We’ve been working with robust and popular web
                            technologies for just about two decades, and it’s
                            something we still love doing today. Whether creating a
                            web presence for your company, an information hub for
                            your business or empowering your apps / IoT devices
                            through backend or an Online Shopping – we cover a wide
                            spectrum of solutions and frameworks by leveraging the
                            power of theinternet.
                          </p>

                          <h4 className="sub-title">MOBILE APPS</h4>
                          <p>
                            From B2B or B2E apps for enterprises, small businesses,
                            and startups, we have a proven track record of creating
                            high-impact, result driven and engaging mobile apps on
                            all popular platforms with Native, Cross-Platform, and
                            Hybrid Technologies.
                          </p>

                          <h4 className="sub-title">UI / UX</h4>
                          <p>
                            Just as the designs themselves, we love the process of
                            creating them as well. The innovative ideas need greater
                            innovation in the way their visual representation is
                            created.
                          </p>
                          <p>
                            We tend to lean more on function over the form. We
                            believe in simplicity and focus. We know the fine
                            differentiator between the visually appealing versus the
                            functional design. We help you craft niche experiences
                            for Web and Mobile via designing Information
                            Architecture, Wireframes, Prototypes and Visual Design.
                          </p>
                        </div>
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="side-panel">
                        <div className="panel">
                          <div className="panel-content">
                            <h3 className="title text-gray mb-3">Requirements</h3>
                            <h4 className="sub-title">Work Experience</h4>
                            <p>
                              {jobData &&
                                jobData.workExperience_min +
                                "-" +
                                jobData.workExperience_max}{" "}
                              years
                            </p>

                            <h4 className="sub-title">Job Type</h4>
                            <p>{jobData && jobData.jobType}</p>

                            <h4 className="sub-title">Posted on</h4>
                            <p>
                              {jobData &&
                                moment(jobData.publishedOn).format("DD MMM YYYY")}
                            </p>

                            <h4 className="sub-title">Skills</h4>
                            {jobData &&
                              jobData?.technologySet &&
                              jobData?.technologySet?.map((item) => {
                                return (
                                  <Badge key={item?._id || item?.skill} variant="dark" className="mr-2">
                                    {item?.skill}
                                  </Badge>
                                );
                              })}
                          </div>
                        </div>
                        <Button
                          size="block"
                          variant="primary"
                          onClick={() => {
                            setInterested(true);
                            setFile(false);
                          }}
                          className="py-3"
                        >
                          Apply Here
                        </Button>
                        {/* <Button type="clear" variant="light" size="block" className="mt-3 py-3">Cancel</Button> */}
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              </div>
            )}
          </Container>
          <Footer />
        </>
      ) : (
        <div className="nic-consultant-page">
          <div className="nic-consultant">
            <main className="nic-main nic-jobdetails" ref={mainRef}>
              {/* Orange banner (was the left sidebar), as wide as the form */}
              <section className="nic-hero">
                <Image
                  src={IndianicLogo}
                  alt="IndiaNIC Infotech Pvt. Ltd."
                  className="nic-hero-logo"
                />
                <div className="nic-hero-copy">
                  <h2 className="nic-hero-title">Your next opportunity awaits</h2>
                  <p className="nic-hero-text">
                    Fill in your details and let us know why you're a great fit for
                    the team.
                  </p>
                </div>
              </section>
              <header className="nic-topbar">
                <div>
                  <button
                    type="button"
                    className="nic-back"
                    onClick={leaveApplication}
                    title="Back to job description"
                  >
                    <span className="bx bx-arrow-back"></span>
                  </button>
                  {jobData && jobData.title && (
                    <>
                      <span className="nic-apply-eyebrow">Apply for</span>
                      <h1 className="nic-apply-title">{jobData.title}</h1>
                    </>
                  )}
                </div>
                <span className="nic-user-avatar" aria-hidden="true">
                  <span className="bx bx-user"></span>
                </span>
              </header>
              {showSteps && renderWizard()}
              <div className="jd-body-panel job-details-panel">
                {interested && !jobSuccess && (
                  <section className="consultant-add-form ">
                    <Row>
                      {/* <Col md={12}>
                  <BreadCrumb
                    routes={[
                      {
                        name: "Job details",
                        path: `/job-detail/${param.id}`,
                      },
                      {
                        name: "Job application",
                      },
                    ]}
                  />
                </Col> */}

                      <Col lg={12}>
                        {/* Form Fields Begins */}
                        <div className="consultant-add-form-body ">
                          <Form onSubmit={handleSubmit}>
                            <div className="panel">
                              <aside
                                className={`doc-upload-block autofill-upload ${isStepActive("upload") ? "" : "d-none"}`}
                                id="nic-upload"
                              >
                                <h4 className="nic-section-title">
                                  <span className="nic-section-badge">
                                    <span className="bx bx-upload"></span>
                                  </span>
                                  Upload Documents
                                </h4>
                                <div id="nic-upload-panel" className="autofill-upload-row">
                                  <div className={`autofill-upload-resume ${errors.file ? "error-red" : ""}`}>
                                    {/* File Uploader */}
                                    <div className="document-file-uploader">

                                      <div className="document-upload">
                                        <div className="document-uploader-block">
                                          {file ? (
                                            <div className="nic-resume-box">
                                              <div className="nic-resume-pill">
                                                <span className={`nic-resume-icon is-${fileType}`}>
                                                  <span className={`bx ${resumeIcon(fileType)}`}></span>
                                                </span>
                                                <div className="nic-resume-info">
                                                  <strong title={file.name}>{file.name}</strong>
                                                  <small>{formatFileSize(file.size)}</small>
                                                </div>
                                                <button
                                                  type="button"
                                                  className="nic-resume-action"
                                                  title="Preview"
                                                  disabled={!preview && !jobApplicationData?.resume}
                                                  onClick={() => setShowPreview(true)}
                                                >
                                                  <span className="bx bx-show"></span>
                                                </button>
                                                <button
                                                  type="button"
                                                  className="nic-resume-action"
                                                  title="Replace resume"
                                                  onClick={() => setShowReplaceResume(true)}
                                                >
                                                  <span className="bx bx-pencil"></span>
                                                </button>
                                                <button
                                                  type="button"
                                                  className="nic-resume-action"
                                                  title="Remove"
                                                  onClick={handleReupload}
                                                >
                                                  <span className="bx bx-x"></span>
                                                </button>
                                              </div>
                                            </div>
                                          ) : (
                                            <>
                                              <div className="file-uploader-block">
                                                <div className="upload-icon-title">
                                                  {/* <span className="bx bx-cloud-upload"></span> */}
                                                  <span className="nic-upload-icon">
                                                    <span className="bx bx-upload"></span>
                                                  </span>
                                                  <p className="upload-icon-title-text">
                                                    Drag &amp; drop resume here
                                                    <span className="text-danger">&nbsp;*</span>
                                                  </p>
                                                  <span className="nic-upload-or">or</span>
                                                  <button
                                                    type="button"
                                                    className="btn btn-dark"
                                                  >
                                                    Browse File
                                                  </button>
                                                  <span className="nic-upload-types">
                                                    {fileTypes.join(", ")}
                                                  </span>
                                                </div>
                                              </div>
                                              <Upload
                                                listType="picture-card"
                                                fileList={fileList}
                                                onChange={onResumeChange}
                                                customRequest={({
                                                  file: resume,
                                                  onSuccess,
                                                  onError,
                                                }) => {
                                                  Promise.resolve().then(() => {
                                                    // Without onSuccess the item sits on "Uploading..."
                                                    onSuccess();
                                                    addResume(resume);
                                                  });
                                                }}
                                                // onPreview={onPreview}
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                onRemove={handleReupload}
                                              >
                                                {fileList.length < 1}
                                              </Upload>{" "}
                                            </>
                                          )}
                                          <input
                                            type="file"
                                            ref={replaceInputRef}
                                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            onChange={onReplaceFileChosen}
                                            hidden
                                          />
                                          {/* {preview && (
                                      <div className="preview-frame">
                                        <iframe src={preview} />{" "}
                                      </div>
                                    )} */}
                                        </div>

                                        {/* {(fileType === "docx" ||
                                    fileType === "doc") && (
                                    <img
                                      src={docIcon}
                                      alt="Word document icon"
                                      className="preview-doc-icon"
                                    />
                                  )} */}
                                      </div>
                                      <small className="error-msg" style={{ color: "red" }}>
                                        {errors.file}
                                      </small>
                                    </div>

                                    {/* File Uploader */}
                                  </div>
                                  <div className="autofill-upload-avatar">
                                    {/* Begin: Attach Image */}
                                    <div
                                      className="document-file-uploader upload-img"
                                      title="Upload profile picture (JPG, PNG, JPEG)"
                                    >
                                      <div className="document-upload">
                                        {profileList && (
                                          <>
                                            <div className="position-relative" ref={avatarRef}>
                                              <div
                                                className="document-uploader-block nic-avatar-trigger"
                                                role="button"
                                                tabIndex={0}
                                                aria-haspopup="menu"
                                                aria-expanded={showPhotoMenu}
                                                aria-label="Add profile picture"
                                                onClick={() => {
                                                  setShowPhotoMenu((open) => !open);
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter" || e.key === " ") {
                                                    e.preventDefault();
                                                    setShowPhotoMenu((open) => !open);
                                                  }
                                                }}
                                              >
                                                <div className="upload-icon-title">
                                                  {/* <span className="bx bx-cloud-upload"></span> */}
                                                  {photoUrl ? (
                                                    <img
                                                      className="nic-avatar-photo"
                                                      src={photoUrl}
                                                      alt="Profile"
                                                    />
                                                  ) : (
                                                    <span className="bx bx-user"></span>
                                                  )}
                                                </div>
                                                <span
                                                  className={`nic-avatar-camera ${photoUrl ? "is-done" : ""}`}
                                                  aria-hidden="true"
                                                >
                                                  <span
                                                    className={`bx ${photoUrl ? "bx-check" : "bx-camera"}`}
                                                  ></span>
                                                </span>

                                                <Upload
                                                  accept=".png,.jpg,.jpeg"
                                                  listType="picture-card"
                                                  showUploadList={false}
                                                  fileList={profileList}
                                                  onChange={(e) => handleImageChange(e)}
                                                  customRequest={({
                                                    file,
                                                    onSuccess,
                                                    onError,
                                                  }) => {
                                                    Promise.resolve().then(() => {
                                                      onSuccess();
                                                      addProfile(file);
                                                    });
                                                  }}
                                                  onPreview={onPreview}
                                                  onRemove={() => {
                                                    setProfileList([]);
                                                    setImage();
                                                    setErrors({
                                                      ...errors,
                                                      successImageFile: "",
                                                    });
                                                  }}
                                                >
                                                  {profileList.length < 1}
                                                </Upload>
                                              </div>
                                              {showPhotoMenu && (
                                                <div className="nic-photo-menu" role="menu">
                                                  {photoUrl ? (
                                                    <>
                                                      <button type="button" role="menuitem" onClick={previewPhoto}>
                                                        <span className="bx bx-show"></span> Preview
                                                      </button>
                                                      <button type="button" role="menuitem" onClick={openPhotoUpload}>
                                                        <span className="bx bx-upload"></span> Upload new
                                                      </button>
                                                      <button type="button" role="menuitem" onClick={openCamera}>
                                                        <span className="bx bx-camera"></span> Capture
                                                      </button>
                                                      <hr className="nic-photo-menu-divider" />
                                                      <button
                                                        type="button"
                                                        role="menuitem"
                                                        className="is-danger"
                                                        onClick={removePhoto}
                                                      >
                                                        <span className="bx bx-trash"></span> Remove
                                                      </button>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <button type="button" role="menuitem" onClick={openCamera}>
                                                        <span className="bx bx-camera"></span> Capture
                                                      </button>
                                                      <button type="button" role="menuitem" onClick={openPhotoUpload}>
                                                        <span className="bx bx-upload"></span> Upload
                                                      </button>
                                                    </>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                            <p className="autofill-upload-avatar-label">
                                              Profile picture
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* Ends: Attach Image */}
                                  </div>
                                </div>
                              </aside>
                              {/* Start: Basic Info */}
                              {renderSectionHeader("basic", "nic-basic", 2, "Basic Info")}
                              {isStepActive("basic") && parsingResume && <FormSkeleton fields={6} />}
                              <div id="nic-basic-panel" className={sectionClass("basic")}>
                                <Row>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formFirstName">
                                      <Form.Label>
                                        First name
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="firstName"
                                          maxLength="20"
                                          className={
                                            errors.firstName !== "" ? "error-red" : ""
                                          }
                                          // disabled={!file}
                                          value={jobApplicationData.firstName}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                            setErrors({
                                              ...errors,
                                              firstName: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.firstName}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formLastName">
                                      <Form.Label>
                                        Last name
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="lastName"
                                          maxLength="20"
                                          // disabled={!file}
                                          className={
                                            errors.lastName !== "" ? "error-red" : ""
                                          }
                                          value={jobApplicationData.lastName}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                            setErrors({
                                              ...errors,
                                              lastName: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.lastName}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formEmail">
                                      <Form.Label>
                                        Email
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="email"
                                          name="email"
                                          maxLength="45"
                                          // disabled={!file}
                                          className={
                                            errors.email !== "" ? "error-red" : ""
                                          }
                                          value={jobApplicationData.email}
                                          onChange={(e) => {
                                            handleDataChange(e, "email");
                                            setErrors({
                                              ...errors,
                                              email: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.email}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formMobile">
                                      <Form.Label>
                                        Mobile
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div className="form-input">
                                        {/* <div className="w-25">
                                    <SimpleSelectComponent
                                      name="mobile"
                                      disabled={!file}
                                      className={
                                        errors.phoneCode
                                          ? "phone-code error-red"
                                          : !file
                                          ? "disabled-field phone-code"
                                          : "phone-code"
                                      }
                                      options={phoneCodeOptionsData}
                                      onValueChange={(e) => {
                                        e &&
                                          setJobApplicationData({
                                            ...jobApplicationData,
                                            phoneCode: e,
                                          });
                                        e &&
                                          setErrors({
                                            ...errors,
                                            phoneCode: "",
                                          });
                                      }}
                                    />
                                    <span
                                      className="error-msg"
                                      style={{ color: "red" }}
                                    >
                                      {errors.phoneCode}
                                    </span>
                                  </div> */}

                                        <div className="w-100">
                                          <PhoneInput
                                            country={"in"}
                                            countryCodeEditable={false}
                                            enableSearch
                                            autoFormat={false}
                                            maxLength={13}
                                            disableSearchIcon={true}
                                            className={
                                              errors.mobile !== "" ? "error-red " : ""
                                            }
                                            value={
                                              jobApplicationData.phoneCode +
                                              jobApplicationData.mobile
                                            }
                                            onChange={async (
                                              phoneNumber,
                                              country
                                            ) => {
                                              formatPhoneNumber(phoneNumber, country);

                                              setErrors({
                                                ...errors,
                                                mobile: "",
                                              });
                                            }}
                                          />

                                          <span
                                            className="error-msg"
                                            style={{ color: "red" }}
                                          >
                                            {errors.mobile}
                                          </span>

                                          {/* <Form.Control
                                      type="number"
                                      onWheel={(e) => e.target.blur()}
                                      className={
                                        errors.mobile !== ""
                                          ? "form-control error-red"
                                          : ""
                                      }
                                      value={jobApplicationData.mobile}
                                      onChange={(e) => {
                                        setJobApplicationData({
                                          ...jobApplicationData,
                                          mobile: e.target.value,
                                        });
                                        setErrors({
                                          ...errors,
                                          mobile: "",
                                        });
                                      }}
                                    /> */}
                                        </div>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formEmail">
                                      <Form.Label>Notice Period</Form.Label>
                                      <span className="text-danger">&nbsp;*</span>
                                      <div>
                                        <SimpleSelectComponent
                                          placeholder="Select notice period"
                                          name="noticePeriod"
                                          // disabled={!file}
                                          value={jobApplicationData.noticePeriod}
                                          options={noticePeriod}
                                          className={
                                            errors.noticePeriod !== ""
                                              ? "error-red"
                                              : ""
                                          }
                                          onValueChange={(e) => {
                                            e &&
                                              setJobApplicationData({
                                                ...jobApplicationData,
                                                noticePeriod: e,
                                              });
                                            setErrors({
                                              ...errors,
                                              noticePeriod: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.noticePeriod}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              {/* Ends: Basic Info */}
                              {/* <div className="divider-x"></div> */}
                              {/* Start: Professional Details */}
                              {renderSectionHeader("professional", "nic-professional", 3, "Professional Details")}
                              {isStepActive("professional") && parsingResume && <FormSkeleton fields={6} />}
                              <div id="nic-professional-panel" className={sectionClass("professional")}>
                                <Row>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formHighQualifHeld">
                                      <Form.Label>
                                        {" "}
                                        Highest Qualification Held
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <SimpleSelectComponent
                                          placeholder="Select qualification"
                                          name="qualification"
                                          // disabled={!file}
                                          value={jobApplicationData.qualification}
                                          // Same plain select as notice period; "form-control"
                                          // here drew a second box around it
                                          className={errors.qualification ? "error-red" : ""}
                                          // options={skillSetOption}
                                          // values={selectedSkill}
                                          onValueChange={(e) => {
                                            e &&
                                              setJobApplicationData({
                                                ...jobApplicationData,
                                                qualificationId: e,
                                                qualification: e,
                                              });
                                            setErrors({
                                              ...errors,
                                              qualification: "",
                                            });
                                          }}
                                        >
                                          {qualificationDetail?.data?.map((data) => (
                                            <option key={data._id} value={data._id}>
                                              {data.qualification}
                                            </option>
                                          ))}
                                        </SimpleSelectComponent>

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.qualification}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formCurrentEmployer">
                                      <Form.Label>
                                        Current Employer
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="currentEmployer"
                                          maxLength="30"
                                          // disabled={!file}
                                          className={
                                            errors.currentEmployer !== ""
                                              ? "error-red"
                                              : ""
                                          }
                                          value={jobApplicationData.currentEmployer}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                            setErrors({
                                              ...errors,
                                              currentEmployer: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.currentEmployer}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formtotalExperiance">
                                      <Form.Label>
                                        Total Experience(IN YEAR)
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="number"
                                          //    disabled={!file}
                                          className={
                                            errors.totalExperiance !== ""
                                              ? "error-red form-control"
                                              : "form-control"
                                          }
                                          value={jobApplicationData.totalExperiance}
                                          onChange={(e) => {
                                            setJobApplicationData({
                                              ...jobApplicationData,
                                              totalExperiance: e.target.value,
                                            });
                                            setErrors({
                                              ...errors,
                                              totalExperiance: "",
                                            });
                                          }}
                                          onKeyDown={(evt) =>
                                            ["e", "E", "+", "-"].includes(evt.key) &&
                                            evt.preventDefault()
                                          }
                                          onInput={(e) => {
                                            if (
                                              e.target.value.length >
                                              e.target.maxLength
                                            )
                                              e.target.value = e.target.value.slice(
                                                0,
                                                e.target.maxLength
                                              );
                                          }}
                                          maxlength={5}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.totalExperiance}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formCurrentSalary">
                                      <Form.Label>
                                        Current Salary(IN LPA)
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="number"
                                          // disabled={!file}
                                          className={
                                            errors.currentSalary !== ""
                                              ? "error-red form-control"
                                              : "form-control"
                                          }
                                          value={jobApplicationData.currentSalary}
                                          onChange={(e) => {
                                            setJobApplicationData({
                                              ...jobApplicationData,
                                              currentSalary: e.target.value,
                                            });
                                            setErrors({
                                              ...errors,
                                              currentSalary: "",
                                            });
                                          }}
                                          onKeyDown={(evt) =>
                                            ["e", "E", "+", "-"].includes(evt.key) &&
                                            evt.preventDefault()
                                          }
                                          onInput={(e) => {
                                            if (
                                              e.target.value.length >
                                              e.target.maxLength
                                            )
                                              e.target.value = e.target.value.slice(
                                                0,
                                                e.target.maxLength
                                              );
                                          }}
                                          maxlength={5}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.currentSalary}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"8"} sm={"6"}>
                                    <Form.Group controlId="formEmail">
                                      <Form.Label>Skill Set</Form.Label>
                                      <span className="text-danger">&nbsp;*</span>
                                      <div>
                                        <MultiSelectComponent
                                          placeholder="Select Skill Set"
                                          name="skillSet"
                                          options={skillSetOption.filter(
                                            (data) => data.label !== ""
                                          )}
                                          values={selectedSkill}
                                          className={
                                            errors.skillSet !== "" ? "error-red " : ""
                                          }
                                          // disabled={!file}
                                          onValuesChange={(e) => {
                                            let list = [];

                                            e.map((item) => list.push(item.value));
                                            e &&
                                              setJobApplicationData({
                                                ...jobApplicationData,
                                                skillSet: list,
                                              });

                                            setSelectedSkill(e);

                                            skillSetOption?.forEach((item) => {
                                              if (
                                                item?.value?.trim() === "" &&
                                                item?.label?.trim() !== ""
                                              ) {
                                                dispatch(
                                                  addSkillsMaster({
                                                    skill: item.label,
                                                  })
                                                );
                                                // setSkillSetOption(e);
                                              }
                                            });
                                            setErrors({
                                              ...errors,
                                              skillSet: "",
                                            });
                                          }}
                                          onSearchChange={(value) => {
                                            if (value && value.trim() !== "") {
                                              const lowercasedValue =
                                                value.toLowerCase();
                                              const isExistingOption =
                                                skillSetOption?.some(
                                                  (option) =>
                                                    option.label?.toLowerCase() ===
                                                    lowercasedValue
                                                );
                                              clearTimeout(typingTimer);
                                              if (!isExistingOption) {
                                                typingTimer = setTimeout(() => {
                                                  let updatedOptions = skillSetOption;
                                                  updatedOptions[
                                                    updatedOptions.length - 1
                                                  ].label = value;
                                                  setSkillSetOption([
                                                    ...updatedOptions,
                                                  ]);
                                                }, 1000);
                                                return;
                                              }
                                            }
                                          }}
                                          onBlur={() => {
                                            let list = [];
                                            skillDetail?.map((item) => {
                                              return list.push({
                                                label: item?.skill,
                                                value: item?._id,
                                              });
                                            });
                                            setSkillSetOption([
                                              ...list,
                                              {
                                                label: "",
                                                value: "",
                                              },
                                            ]);
                                          }}
                                          onRemoveItem={function (item) {
                                            const skills = selectedSkill?.filter(
                                              function (d) {
                                                return item.value !== d?.value;
                                              }
                                            );
                                            setSelectedSkill(skills);
                                          }}
                                        />
                                        {/* <MultiSelectComponent
                                      name="skillSet"
                                      placeholder="Type to select"
                                      options={skillSetOption}
                                      values={selectedSkill}
                                      className={
                                        errors.skillSet !== "" ? "error-red " : ""
                                      }
                                      // disabled={!file}
                                      onValuesChange={(e) => {
                                        let list = [];
                                        e.map((item) => list.push(item.value));
                                        e &&
                                          setJobApplicationData({
                                            ...jobApplicationData,
                                            skillSet: list,
                                          });
                                        setSelectedSkill(e);
                                        setErrors({
                                          ...errors,
                                          skillSet: "",
                                        });
                                      }}
                                      onSearchChange={(e) => {
                                        getSkillSetList(e);
                                      }}
                                      onRemoveItem={function (item) {
                                        const skills = selectedSkill?.filter(
                                          function (d) {
                                            return item.value !== d?.value;
                                          }
                                        );
                                        setSelectedSkill(skills);
                                      }}
                                    ></MultiSelectComponent> */}
                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.skillSet}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              {/* Ends: Professional Details */}
                              {/* Begin: Experience Details */}
                              {renderSectionHeader("experience", "nic-experience", 4, "Experience Details")}
                              {isStepActive("experience") && parsingResume && <FormSkeleton fields={3} />}
                              <div id="nic-experience-panel" className={sectionClass("experience")}>
                                {experienceDetails.map(renderExperience)}
                                <button
                                  type="button"
                                  className="nic-entry-add"
                                  onClick={handleExeperienceAdd}
                                >
                                  <span className="bx bx-plus"></span> Add experience
                                </button>
                              </div>
                              {/* Ends: Experience Details */}
                              {/* Begin: Education Details */}
                              {renderSectionHeader("education", "nic-education", 5, "Education Details")}
                              {isStepActive("education") && parsingResume && <FormSkeleton fields={3} />}
                              <div id="nic-education-panel" className={sectionClass("education")}>
                                {educationDetails.map(renderEducation)}
                                <button
                                  type="button"
                                  className="nic-entry-add"
                                  onClick={handleAddEducation}
                                >
                                  <span className="bx bx-plus"></span> Add education
                                </button>
                              </div>
                              {/* Ends: Education Details */}
                              {/* Begin: Address Details */}
                              {renderSectionHeader("address", "nic-address", 6, "Address Details")}
                              {isStepActive("address") && parsingResume && <FormSkeleton fields={6} />}
                              <div id="nic-address-panel" className={sectionClass("address")}>
                                <Row>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formStreet">
                                      <Form.Label>Street</Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="street"
                                          maxLength="45"
                                          // disabled={!file}

                                          className={
                                            errors.skillSet !== ""
                                              ? "error-red form-control"
                                              : "form-control"
                                          }
                                          value={jobApplicationData.street}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                          }}
                                        />
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formZip">
                                      <Form.Label>Zip / Postal Code</Form.Label>
                                      <div>
                                        <InputMask
                                          // disabled={!file}
                                          className={"form-control"}
                                          mask={
                                            jobApplicationData.zipCode !== ""
                                              ? "999999"
                                              : ""
                                          }
                                          maskChar=""
                                          value={jobApplicationData.zipCode}
                                          onChange={(e) =>
                                            setJobApplicationData({
                                              ...jobApplicationData,
                                              zipCode: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                      {/* <Form.Control
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(e) => {
                                    setJobApplicationData({
                                      ...jobApplicationData,
                                      zipCode: e.target.value,
                                    });
                                  }}
                                /> */}
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formCity">
                                      <Form.Label>
                                        City
                                        <span className="text-danger">&nbsp;*</span>
                                      </Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="city"
                                          maxLength="30"
                                          // disabled={!file}
                                          className={
                                            errors.city !== "" ? "error-red" : ""
                                          }
                                          value={jobApplicationData.city}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                            setErrors({
                                              ...errors,
                                              city: "",
                                            });
                                          }}
                                        />

                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.city}
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formProvince">
                                      <Form.Label>State / Province</Form.Label>
                                      <div>
                                        <Form.Control
                                          type="text"
                                          name="state"
                                          maxLength="30"
                                          // disabled={!file}
                                          // className={!file ? "disabled-field" : ""}
                                          value={jobApplicationData.state}
                                          onChange={(e) => {
                                            handleDataChange(e);
                                          }}
                                        />
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col md={"4"} sm={"6"}>
                                    <Form.Group controlId="formCountry">
                                      <Form.Label>Country</Form.Label>
                                      <span className="text-danger">&nbsp;*</span>
                                      <div>
                                        <SimpleSelectComponent
                                          placeholder="Select country"
                                          className={
                                            errors.country !== "" ? "error-red" : ""
                                          }
                                          options={countryOptions}
                                          value={
                                            jobApplicationData?.country
                                              ? {
                                                label: jobApplicationData.country,
                                                value: jobApplicationData.country,
                                              }
                                              : undefined
                                          }
                                          onValueChange={(e) => {
                                            if (e === undefined) {
                                              setJobApplicationData({
                                                ...jobApplicationData,
                                                country: "",
                                              });
                                            } else {
                                              setJobApplicationData({
                                                ...jobApplicationData,
                                                country: e.value,
                                              });
                                              setErrors({ ...errors, country: "" });
                                            }
                                          }}
                                        />
                                        <span
                                          className="error-msg"
                                          style={{ color: "red" }}
                                        >
                                          {errors.country}
                                        </span>
                                        {/* <Form.Control
                                      type="text"
                                      name="country"
                                      maxLength="30"
                                      // disabled={!file}
                                      // className={!file ? "disabled-field" : ""}
                                      value={jobApplicationData.country}
                                      onChange={(e) => {
                                        handleDataChange(e);
                                      }}
                                    /> */}
                                      </div>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              {/* Ends: Address Details */}
                            </div>

                            {/* Begin: Step buttons (Back / Next, Submit on the last step) */}
                            <div className="button-group nic-actions">
                              {!isLoading && activeStep > 0 && (
                                <Button
                                  variant="outline-secondary"
                                  type="button"
                                  className="nic-btn-clear nic-btn-back"
                                  onClick={() => goToStep(activeStep - 1)}
                                >
                                  <span className="bx bx-left-arrow-alt"></span> Back
                                </Button>
                              )}
                              {!isLoading && activeStep < LAST_STEP && (
                                <Button
                                  variant="dark"
                                  type="button"
                                  className="nic-btn-submit"
                                  disabled={activeStep === 0 && stepsLocked}
                                  title={activeStep === 0 && !file ? "Upload your resume to continue" : undefined}
                                  onClick={goNext}
                                >
                                  Next{" "}
                                  <span
                                    className={`bx ${parsingResume ? "bx-loader-alt bx-spin" : "bx-right-arrow-alt"}`}
                                  ></span>
                                </Button>
                              )}
                              {!isLoading && activeStep === LAST_STEP && (
                                <>
                                  <Button
                                    variant="outline-secondary"
                                    type="button"
                                    className="nic-btn-clear"
                                    onClick={resetData}
                                  >
                                    Clear
                                  </Button>
                                  <Button
                                    variant="dark"
                                    type="submit"
                                    className="nic-btn-submit"
                                    disabled={isLoading}
                                  >
                                    Submit <span className="bx bx-right-arrow-alt"></span>
                                  </Button>
                                </>
                              )}
                              {isLoading && (
                                <>
                                  <Button variant="dark" className="nic-btn-submit" disabled>
                                    Please wait a moment...
                                    <Spinner
                                      animation="border"
                                      variant="light"
                                      className="spinner-loader ml-2"
                                    />
                                  </Button>
                                </>
                              )}
                            </div>
                            {/* Ends: Submit Button */}
                          </Form>
                        </div>
                        {/* Form Fields Ends */}
                      </Col>
                    </Row>
                  </section>
                )}
              </div>
              {/* Contact line at the foot of the page (moved out of the sidebar) */}
              <div className="nic-help-bar">
                <p className="nic-help-bar-title">Need help?</p>
                <a href="tel:+917961916000">
                  <span className="bx bx-phone"></span>+91 79 6191 6000
                </a>
                <a href="mailto:hr@indianic.com">
                  <span className="bx bx-envelope"></span>hr@indianic.com
                </a>
              </div>
            </main>
          </div>
        </div>
      )}

      <Modal
        show={showReplaceResume}
        onHide={() => setShowReplaceResume(false)}
        centered
        className="nic-replace-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Replace resume</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to update only the resume file, or also update your
          profile details based on the new resume?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-dark"
            className="nic-replace-only"
            onClick={() => chooseReplaceMode("resume")}
          >
            Only resume
          </Button>
          <Button
            className="nic-replace-full"
            onClick={() => chooseReplaceMode("full")}
          >
            Resume + profile data
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPhotoPreview && !!photoUrl}
        onHide={() => setShowPhotoPreview(false)}
        centered
        className="nic-camera-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Profile picture</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img className="nic-photo-preview" src={photoUrl} alt="Profile" />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCamera}
        onHide={() => setShowCamera(false)}
        centered
        className="nic-camera-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Capture profile picture</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {cameraError ? (
            <p className="nic-camera-error">{cameraError}</p>
          ) : (
            <div className="nic-camera-frame">
              <video
                ref={videoRef}
                autoPlay
                playsInline
                muted
                style={{ display: capturedPhoto ? "none" : "block" }}
              />
              {capturedPhoto && <img src={capturedPhoto} alt="Captured" />}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {cameraError ? (
            <Button
              variant="dark"
              onClick={() => {
                setShowCamera(false);
                openPhotoUpload();
              }}
            >
              <span className="bx bx-upload"></span> Upload instead
            </Button>
          ) : capturedPhoto ? (
            <>
              <Button variant="outline-secondary" onClick={() => setCapturedPhoto("")}>
                Retake
              </Button>
              <Button variant="dark" onClick={applyCapturedPhoto}>
                Use photo
              </Button>
            </>
          ) : (
            <Button variant="dark" onClick={takePhoto}>
              <span className="bx bx-camera"></span> Take photo
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={show} centered onHide={handleClose} className="nic-success-modal">
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="nic-success-hero">
            <span className="nic-success-icon">
              <span className="bx bx-check"></span>
            </span>
            <h4 className="nic-success-title">Application submitted!</h4>
            {jobData?.title && (
              <p className="nic-success-subtitle">
                Thank you for applying for <strong>{jobData.title}</strong>
              </p>
            )}
          </div>

          <div className="nic-success-message">
            <p>
              Dear {successData?.candidateData?.firstName}{" "}
              {successData?.candidateData?.lastName},
            </p>
            {/* Message from the admin settings; a placeholder like "- -" falls back to the default text */}
            {hasThankYouMsg ? (
              <div dangerouslySetInnerHTML={{ __html: thankYouMsg }}></div>
            ) : (
              <p>
                Thank you for applying and sharing the information. Our team
                will get in touch with you soon. If there's no matching opening
                right now, look out for emails from IndiaNIC; we'll be in touch
                when a suitable vacancy opens up.
              </p>
            )}
          </div>

          <ul className="nic-success-info">
            {successData?.candidateData?.emailId && (
              <li>
                <span className="nic-success-info-icon bx bx-envelope"></span>
                <div>
                  <small>Further updates will be sent to</small>
                  <a href={`mailto:${successData.candidateData.emailId}`}>
                    {successData.candidateData.emailId}
                  </a>
                </div>
              </li>
            )}
            <li>
              <span className="nic-success-info-icon bx bx-globe"></span>
              <div>
                <small>To know more about IndiaNIC</small>
                <a href="https://www.indianic.com" target="_blank" rel="noopener noreferrer">
                  www.indianic.com
                </a>
              </div>
            </li>
          </ul>

          {(successContact?.primary || successContact?.secondary) && (
            <div className="nic-success-contacts">
              {[successContact.primary, successContact.secondary]
                .filter(Boolean)
                .map((contact, index) => (
                  <div className="nic-success-contact" key={index}>
                    <strong>{contact.title}</strong>
                    {contact.email && <a href={`mailto:${contact.email}`}>{contact.email}</a>}
                    {contact.contact && <span>{contact.contact}</span>}
                  </div>
                ))}
            </div>
          )}

          <div className="nic-success-sign">
            <strong>HR Team</strong>
            <span>Have a good day and best wishes for your further process!</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" className="nic-success-ok" onClick={resetData}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPreview} size="lg" onHide={() => setShowPreview(false)}>
        <Modal.Header closeButton>
          {/* <h5 className="text-secondary">Preview</h5>
          <div className="text-center">
          </div> */}
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          {resumePreviewUri && (
            <DocViewer
              documents={[
                {
                  uri: resumePreviewUri,
                  fileType: fileType,
                  fileName: file?.name,
                },
              ]}
              pluginRenderers={[
                PDFRenderer,
                MSDocRenderer,
                PNGRenderer,
                JPGRenderer,
              ]}
              style={{
                width: "100%",
                height: "100%",
                textAlign: "center",
              }}
              theme={{
                primary: "#5296d8",
                secondary: "#00000099",
                tertiary: "#5296d899",
                text_primary: "#ffffff",
                text_secondary: "#5296d8",
                text_tertiary: "#00000099",
                disableThemeScrollbar: false,
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowPreview(false);
            }}
          >
            Close
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              setShowPreview(false);
              handleReupload();
            }}
          >
            Re-Upload
          </Button>
        </Modal.Footer>
      </Modal>

    </React.Fragment>
  );
};

export default JobDetails;
